/**
 * @generated SignedSource<<cc0504ec50762580f35f5450a31ba9fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type expiringPromoMessageHelpers_expiringPromotion$data = {
  readonly daysRelativeToExpiration: string | null;
  readonly promotionMeta: {
    readonly urgencyMessagingDaysBeforeExpiration: number | null;
    readonly urgencyMessagingDisplay: boolean | null;
  } | null;
  readonly " $fragmentType": "expiringPromoMessageHelpers_expiringPromotion";
};
export type expiringPromoMessageHelpers_expiringPromotion$key = {
  readonly " $data"?: expiringPromoMessageHelpers_expiringPromotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"expiringPromoMessageHelpers_expiringPromotion">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "expiringPromoMessageHelpers_expiringPromotion"
};

(node as any).hash = "89addd7466942b1e9d53058e1b0457f3";

export default node;
